// ============================================================
// Notificações Push (03/08/2026, pedido do Juan) — pede permissão
// ao navegador e registra a inscrição no momento do login. Chamado
// de dentro do AuthContext, depois de um login bem-sucedido —
// nunca bloqueia o login em si (tudo aqui é best-effort: se o
// navegador não suportar, se o usuário negar, ou se der qualquer
// erro, o login segue normal, só sem notificação).
// ============================================================

// Base64 URL-safe -> Uint8Array, formato que o Push API exige pra
// applicationServerKey (a chave pública VAPID vem em base64 do
// backend, mas a API do navegador só aceita como bytes).
function urlBase64ParaUint8Array(base64) {
  const padding = '='.repeat((4 - (base64.length % 4)) % 4);
  const base64Seguro = (base64 + padding).replace(/-/g, '+').replace(/_/g, '/');
  const bruto = atob(base64Seguro);
  return Uint8Array.from([...bruto].map(c => c.charCodeAt(0)));
}

export async function inscreverNotificacoesPush(API) {
  if (!('serviceWorker' in navigator) || !('PushManager' in window) || !('Notification' in window)) {
    return; // navegador não suporta — não é erro, só não faz nada
  }
  // Já tinha negado antes — não insiste toda vez que loga (o
  // navegador nem mostra o prompt de novo nesse caso, mas evita a
  // chamada desnecessária de qualquer forma).
  if (Notification.permission === 'denied') return;

  try {
    /* `requestPermission` com permissão já concedida devolve 'granted'
       na hora, sem prompt — então não há custo em chamar sempre, e é o
       que garante o pedido para quem nunca decidiu. */
    const permissao = Notification.permission === 'granted'
      ? 'granted'
      : await Notification.requestPermission();
    if (permissao !== 'granted') return;

    const registration = await navigator.serviceWorker.ready;

    const { data } = await API.get('/notificacoes/push/chave-publica');
    if (!data?.chave) return; // backend sem VAPID configurada ainda

    /* ⚠ INSCRIÇÃO NO NAVEGADOR NÃO É INSCRIÇÃO NO SERVIDOR (corrigido em
       28/08/2026, relato do Juan: "as notificações de push ainda não
       estão vindo").

       Havia aqui um `if (jaInscrito) return` — se o navegador já tinha
       uma inscrição, a função parava. Parece razoável e está errado: são
       DOIS registros, um no navegador e outro em `push_subscriptions`.
       Se o do servidor se perdeu — troca de aparelho, limpeza de dados,
       reinstalação do app, ou a faxina que apaga endpoint com erro 410 —
       o navegador continuava dizendo "já estou inscrito" e o servidor
       nunca voltava a saber deste aparelho.

       O efeito é exatamente o que o Juan descreveu: a pendência aparece
       ao abrir o app, porque a tela consulta o banco; e o push nunca
       chega, porque não há para onde mandar.

       Agora a inscrição do navegador é REAPROVEITADA quando existe, e o
       envio ao servidor acontece SEMPRE. O `POST` é idempotente — grava
       por endpoint — então repetir não duplica. */
    let subscription = await registration.pushManager.getSubscription();
    if (!subscription) {
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ParaUint8Array(data.chave),
      });
    }

    const json = subscription.toJSON();
    await API.post('/notificacoes/push/inscrever', {
      endpoint: json.endpoint,
      keys: json.keys,
    });
  } catch (err) {
    console.warn('[push] Não foi possível inscrever para notificações:', err.message);
  }
}
